/**
 * Phase 0 user-visible copy for รายงานคุณภาพ (Drive landing only).
 */
export const QUALITY_REPORTS_PAGE_TITLE = 'รายงานคุณภาพ';

export const QUALITY_REPORTS_DRIVE_LINK_LABEL = 'เปิดโฟลเดอร์รายงานคุณภาพ';

export const QUALITY_REPORTS_HELP =
  'เปิดโฟลเดอร์ Drive เพื่อดูไฟล์รายงานคุณภาพรายเดือน ยังไม่มีการส่งในระบบนี้';

/** In-app nav label (distinct from Drive catalog "เอกสารรายงานคุณภาพปีงบประมาณ 2567 - 2569"). */
export const QUALITY_REPORTS_NAV_LABEL = 'รายงานคุณภาพ';
